import React, { useEffect } from 'react';
import { SiSubstack as _SiSubstack } from 'react-icons/si';
const SiSubstack = _SiSubstack as unknown as React.ComponentType<any>;

interface SubstackButtonProps {
  label?: string;
}

const SubstackButton: React.FC<SubstackButtonProps> = ({ label = 'Subscribe' }) => {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center transition text-white bg-[var(--color-main-accent)] space-x-2 px-3 py-2 rounded-md font-bold"
        aria-label="Subscribe to Substack"
      >
        <SiSubstack className="w-4 h-4" />
        <span className="text-sm font-medium">{label}</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-6" style={{ backgroundColor: 'transparent' }}>
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <div className="relative rounded-md shadow-lg max-w-[95vw] w-[520px]" style={{ backgroundColor: 'var(--color-bg-primary)', border: '1px solid var(--color-border)' }}>
            <div className="p-4 border-b" style={{ borderColor: 'var(--color-border)' }}>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <SiSubstack className="w-5 h-5" />
                  <strong className='text-xl'>{label}</strong>
                </div>
                <button onClick={() => setOpen(false)} aria-label="Close subscribe modal" className="text-2xl px-3 py-1 leading-none">×</button>
              </div>
            </div>
            <div className="p-6">
              <iframe
                src="https://pfjacobs.substack.com/embed"
                width="480"
                height="320"
                frameBorder={0}
                scrolling="no"
                style={{ width: '100%', maxWidth: 480 }}
                title="Subscribe to my Substack"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubstackButton;
